import { Dialog, EmptyState, Icon, Icons, Intent, List, ListItem } from "construct-ui";
import { COMMON_SEARCH_DATA_TYPES } from "../../../config/constants";
import codeMasterModel from "../../../models/common/code-master.model";
import ViewBase from "../../../views/view-base.view";
import paginationComponent from "../../pagination/pagination.component";


let uniqueInstance = 1;

/**
 * Select Common Search Search Input Dialog
 * 
 * Select Common Search Dialog with filters to search for Common Popup.
 * 
 * Supports multiple or single inputs
 * 
 * @author cmcnkhiep
 */
export default function SelectCommonSearchInputDialog() {
  ViewBase.call(this);

  const COMMON_SEARCH_LABEL = {
    [COMMON_SEARCH_DATA_TYPES.VENDOR]: { dataType: 'POSM_VENDOR', dataCode: this.getText('LT00001289', 'Vendor ID'), dataName: this.getText('LT00001088', 'Vendor') },
  }
  const UID = uniqueInstance++;

  const KEY_MODEL_CODE = 'name';

  const ID_DIALOG = `SelectCommonSearchInputDialog${UID}`;
  const ID_SEARCH_RESULTS = `SelectCommonSearchInputDialog-SearchResults${UID}`;
  const ID_SELECT_ALL_CHECKBOX = `SelectCommonSearchInputDialog-SelectAllCheckbox${UID}`;

  const DEFAULT_ONCLOSE = () => { console.log('SelectCommonSearchInputDialog: onClose()') };
  const DEFAULT_ONSELECT = (selectedItemsItem) => { console.log('SelectCommonSearchInputDialog: onSelect(selectedItems | selectedItem)'); };
  const RESULT_LIST_HEIGHT = '50vh';

  const DEFAULT_FILTERS = {
    dataCode: '',
    dataName: '',
    parDataCode: ''
  };

  const DEFAULT_PAGINATION = {
    pageIndex: 1,
    pageSize: 10,
    total: 0
  };

  let dataType = '';
  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  const API_REQUEST_PARAMS = {
    get dataType() { return dataType },
    get dataCode() { return filters.dataCode },
    get dataName() { return filters.dataName },
    get parDataCode() { return filters.parDataCode },
    get pageIndex() { return pagination.pageIndex },
    get pageSize() { return pagination.pageSize },
  };

  let commonData = [];

  const searchCommonCodeName = (selectedItem) => {
    this.showLoading();

    commonData = [];
    return codeMasterModel.getCommonCodeNameForPopup(API_REQUEST_PARAMS)
      .then(result => {
        if (result != null) {
          commonData = result.data;
          pagination.total = result.total;
        }
      })
      .catch(error => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }


  const onSearch = (multiple, selectedItems) => (e) => {
    e.preventDefault();
    pagination = structuredClone(DEFAULT_PAGINATION);
    document.getElementById(ID_SEARCH_RESULTS).scrollIntoView({ behavior: 'auto', block: 'end' });
    searchCommonCodeName()
      .then(() => {
        if (multiple) {
          updateSelectAllCheckbox(selectedItems)
        }
      });
  }

  const onDeselect = (selectedItems, onSelect, deselectItem) => {
    let result = structuredClone(selectedItems);
    const index = result.findIndex((element) => deselectItem.code === element.code);
    if (index >= 0) {
      result.splice(index, 1);
    }

    updateSelectAllCheckbox(result);
    onSelect(result);
  }

  const onDeselectAll = (onSelect) => {
    updateSelectAllCheckbox([]);
    onSelect([]);
  }

  const reset = () => {
    clearFilters();
    pagination = structuredClone(DEFAULT_PAGINATION);
    commonData = [];
  }

  const clearFilters = () => {
    filters = structuredClone(DEFAULT_FILTERS);
  }

  const isSelected = (selectedItems, code) => {
    return selectedItems.find((model => model.code === code));
  }

  const clickCheckbox = (code) => (e) => {
    e.stopPropagation();
    document.getElementById(code).click();
  };

  const onCheckAll = (selectedItems, onSelect) => (e) => {
    let resultMap = selectedItems.reduce((accumulator, item) => {
      accumulator[item.code] = item;
      return accumulator;
    }, {});

    let checkedInputs = document.querySelectorAll(`#${ID_DIALOG} tbody input:checked`);
    e.target.checked = checkedInputs.length !== commonData.length;


    commonData.forEach(model => {
      if (e.target.checked) {
        resultMap[model.code] = model;
      } else {
        delete resultMap[model.code];
      }
    });

    onSelect(Object.values(resultMap));
  };

  const onCheck = (selectedItems, onSelect, selectedItem) => (e) => {
    e.stopPropagation();
    let result = structuredClone(selectedItems);

    if (e.target.checked) {
      result.push(selectedItem);
    } else {
      const index = result.findIndex((model) => model.code === selectedItem.code);
      result.splice(index, 1);
    }

    updateSelectAllCheckbox(result);
    onSelect(result);
  };

  const updateSelectAllCheckbox = (selectedItems) => {
    let resultMap = selectedItems.reduce((accumulator, item) => {
      accumulator[item.code] = item;
      return accumulator;
    }, {});

    let count = 0;
    commonData.forEach(model => {
      if (resultMap.hasOwnProperty(model.code)) {
        count++;
      }
    });

    let selectAllCheckbox = document.getElementById(ID_SELECT_ALL_CHECKBOX);
    if (count === 0) {
      selectAllCheckbox.checked = false;
      selectAllCheckbox.indeterminate = false;
    } else if (count === commonData.length) {
      selectAllCheckbox.checked = true;
      selectAllCheckbox.indeterminate = false;
    } else {
      selectAllCheckbox.indeterminate = true;
    }
  };

  const searchViewSingle = (selectedItem, onSelect) => m(`#${ID_SEARCH_RESULTS}.col`, { style: { height: RESULT_LIST_HEIGHT } },
    m('.card.h-100',
      m('.card-body.h-100',
        m('.vstack.h-100',
          m('.table-responsive.h-100',
            m('table.table.table-hover.table-bordered',
              m('thead',
                m('tr.text-center',
                  m('td'),
                  m('th', COMMON_SEARCH_LABEL[dataType]?.dataCode),
                  m('th', COMMON_SEARCH_LABEL[dataType]?.dataName)
                )
              ),
              m('tbody',
                commonData.length > 0
                  ? commonData.map(model => m('tr.cursor-pointer', { onclick: clickCheckbox(model.code) },
                    m('td.text-center',
                      m(`input#${model.code}`, {
                        type: 'checkbox',
                        checked: selectedItem?.code == model.code,
                        onclick: (e) => {
                          if (e.target.checked) {
                            onSelect({ code: null, name: null });
                          } else onSelect(model);
                        }
                      })
                    ),
                    m('td', model.code),
                    m('td', model.name)
                  ))
                  : m('tr',
                    m('td', { colspan: 5 }, this.getText("EM00000141", "No records found."))
                  )
              )
            )
          ),
          commonData.length > 0 && m(paginationComponent, {
            currentPage: pagination.pageIndex,
            pageSize: pagination.pageSize,
            totalItems: pagination.total,
            onPageChanged: (pageIndex) => {
              pagination.pageIndex = pageIndex;
              searchCommonCodeName()
                .then(() => { updateSelectAllCheckbox([selectedItem]) });
            },
            onPageSizeChanged: (pageIndex, pageSize) => {
              pagination.pageIndex = pageIndex;
              pagination.pageSize = pageSize;
              searchCommonCodeName()
                .then(() => { updateSelectAllCheckbox([selectedItem]) });
            }
          })
        )
      )
    )
  );

  const searchViewMultiple = (selectedItems, onSelect) => m('.row.g-1',
    m('.col-lg-3.order-lg-2', { style: { height: RESULT_LIST_HEIGHT } },
      m('.card.h-100',
        m('.card-body.h-100',
          selectedItems.length > 0
            ? m(List, { class: 'h-100', interactive: true },
              selectedItems.map(item => m(ListItem, {
                label: item[KEY_MODEL_CODE],
                contentRight: m(Icon, {
                  name: Icons.X,
                  intent: Intent.NEGATIVE,
                  onclick: () => { onDeselect(selectedItems, onSelect, item) }
                }),
              }))
            )
            : m(EmptyState, {
              class: 'placeholder-text-color',
              style: { position: 'static' },
              icon: Icons.DATABASE,
              content: this.getText('LT00000719', 'No items selected'),
              fill: true
            })
        )
      )
    ),
    m('.col-lg-12.order-lg-3',
      m('.hstack.gap-2.justify-content-end',
        m('a.small.cursor-pointer', {
          onclick: () => {
            onDeselectAll(onSelect);
          }
        }, this.getText('LT00000545', 'Clear selections')),
        m('small', `${selectedItems.length} record(s)`)
      )
    ),
    m(`#${ID_SEARCH_RESULTS}.col-lg-9.order-lg-1`, { style: { height: RESULT_LIST_HEIGHT } },
      m('.card.h-100',
        m('.card-body.h-100',
          m('.vstack.h-100',
            m('.table-responsive.h-100',
              m('table.table.table-hover.table-bordered',
                m('thead',
                  m('tr.text-center',
                    m('td',
                      m('input', {
                        id: ID_SELECT_ALL_CHECKBOX,
                        type: 'checkbox',
                        onclick: onCheckAll(selectedItems, onSelect)
                      })
                    ),
                    m('th', COMMON_SEARCH_LABEL[dataType]?.dataCode),
                    m('th', COMMON_SEARCH_LABEL[dataType]?.dataName)
                  )
                ),
                m('tbody',
                  commonData.length > 0
                    ? commonData.map(model => m('tr.cursor-pointer', { onclick: clickCheckbox(model.code) },
                      m('td.text-center',
                        m(`input#${model.code}`, {
                          type: 'checkbox',
                          checked: isSelected(selectedItems, model.code),
                          onclick: onCheck(selectedItems, onSelect, model)
                        })
                      ),
                      m('td', model.code),
                      m('td', model.name)
                    ))
                    : m('tr',
                      m('td', { colspan: 5 }, this.getText("EM00000141", "No records found."))
                    )
                )
              )
            ),
            commonData.length > 0 && m(paginationComponent, {
              currentPage: pagination.pageIndex,
              pageSize: pagination.pageSize,
              totalItems: pagination.total,
              onPageChanged: (pageIndex) => {
                pagination.pageIndex = pageIndex;
                searchCommonCodeName()
                  .then(() => { updateSelectAllCheckbox(selectedItems) });
              },
              onPageSizeChanged: (pageIndex, pageSize) => {
                pagination.pageIndex = pageIndex;
                pagination.pageSize = pageSize;
                searchCommonCodeName()
                  .then(() => { updateSelectAllCheckbox(selectedItems) });
              }
            })
          )
        )
      )
    )
  );

  const searchViewFunctions = [searchViewSingle, searchViewMultiple];

  return {
    oninit: ({ attrs }) => {
      dataType = attrs.dataType;
    },
    view: ({ attrs: {
      selectedItems = [],
      selectedItem = null,
      multiple = false,
      isOpen = false,
      onSelect = DEFAULT_ONSELECT,
      onClose = DEFAULT_ONCLOSE } }) => {

      if (commonData.length == 0) {
        if (selectedItem?.code && selectedItem?.name) {
          commonData.push(selectedItem);
        }
      }
      return m(Dialog, {
        class: 'cui-dialog-xl',
        isOpen,
        closeOnOutsideClick: false,
        closeOnEscapeKey: false,
        onClose: onClose,
        onClosed: () => {
          reset();
        },
        onOpened: () => {
          if (isOpen && selectedItems.length > 0) {
            updateSelectAllCheckbox(selectedItems);
          }
        },
        title: `${COMMON_SEARCH_LABEL[dataType]?.dataName} ${this.getText('LT00000001', 'Search')}`,
        content: [
          m(`#${ID_DIALOG}.vstack.gap-2`,
            m('.hstack.justify-content-end',
              m('.d-block.d-sm-block.d-md-none',
                m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="false"]',
                  m("i.bi.bi-filter"),
                  this.getText("LT00000232", "Filter")
                )
              )
            ),
            m(".collapse.show#search-section",
              m('.card',
                m('.card-body',
                  m('form.row.g-2', { onsubmit: onSearch(multiple, selectedItems) },
                    m('.col-md-3',
                      m('label.form-label', COMMON_SEARCH_LABEL[dataType]?.dataCode),
                      m('input.form-control', {
                        type: 'text',
                        maxlength: 50,
                        value: filters.dataCode,
                        placeholder: COMMON_SEARCH_LABEL[dataType]?.dataCode,
                        onchange: (e) => {
                          filters.dataCode = e.target.value.trim();
                        }
                      })
                    ),
                    m('.col-md-3',
                      m('label.form-label', COMMON_SEARCH_LABEL[dataType]?.dataName),
                      m('input.form-control', {
                        type: 'text',
                        maxlength: 50,
                        value: filters.dataName,
                        placeholder: COMMON_SEARCH_LABEL[dataType]?.dataName,
                        onchange: (e) => {
                          filters.dataName = e.target.value.trim();
                        }
                      })
                    ),
                    m('.col-12',
                      m('.d-flex.gap-2.justify-content-end',
                        m('button.btn.btn-primary', this.getText("LT00000001", "Search")),
                        m('button.btn.btn-white', { type: 'button', onclick: clearFilters }, this.getText("LT00000031", "Clear"))
                      )
                    )
                  ),
                )
              )
            ),
            m('div',
              searchViewFunctions[+multiple](multiple ? selectedItems : selectedItem, onSelect)
            )
          ),
          this.getBaseViews()
        ],
        footer: m('.hstack.justify-content-end',
          m('button.btn.btn-white', { onclick: onClose }, this.getText('LT00000021', 'Close'))
        )
      })
    }
  }
}